import { FieldModel, FieldType } from "./field";
import * as fp from 'lodash/fp';
import moment from "moment";
import { defaultDateTimeFormat } from "src/constants/defaults";

export class UserFieldResponse {
	static fromAny(data: any) {
		return new UserFieldResponse(data.fieldId, data.response);
	}

	static fromFormValues(formValues: any): Array<any> {
		return fp.flow(
			fp.mapValues((value) => fp.isObject(value) ? (value as any).id : value),
			fp.toPairs,
			fp.filter(([fieldId, response]) => fieldId && response),
			fp.map(([fieldId, response]) => ({ fieldId, response }))
		)(formValues);
	}

	get formattedResult(): { presentation: string, value: string } {
		const res = {
			presentation: this.response,
			value: this.response,
		};

		if (fp.has("field.type", this.meta)) {
			switch (this.meta?.field?.type) {
				case FieldType.DDL || FieldType.Radio:
					const tmp = this.meta.field.options.find(o => o.id === this.response);
					res.presentation = tmp?.name;
					res.value = tmp?.id;
					break;

				case FieldType.DateTime:
					res.presentation = moment(this.response).format(this.meta.field.displayFormat || defaultDateTimeFormat);
					break;
			}
		}

		return res;
	}

	constructor(
		public fieldId: string,
		public response: any,
		public meta?: { field?: FieldModel }
	) { }

	toDto() {
		return new UserFieldResponse(this.fieldId, this.response);
	}

	toUpdateRequestDto() {
		return new UserFieldResponse(this.fieldId, this.response, this.meta);
	}

	toFieldsValue(responseValue: any) {
		let description = `"${this.meta?.field?.name}"=`;
		switch (this.meta?.field?.type) {
			case FieldType.DDL || FieldType.Radio:
				description += `"${this.meta!.field!.options.find(o => o.id === responseValue)?.name}";`;
				break;
			default:
				description += `"${responseValue}";`;
				break;
		}
		return description;
	}
}